// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRP_header__u7cMY","image-wrapper":"infoRP_image-wrapper__3Im3g"};